/*
 * @Descripttion:
 * @Version: 1.0
 * @Author: 张家彬
 * @Date: 2024-04-29 14:46:51
 * @LastEditors: 张家彬
 * @LastEditTime: 2024-06-07 09:39:35
 */
// export const storageToken = 'token';
export const storageUserName = 'username';
const market = 'Market-';

// 当前用户信息
export const storeKeyCurrentUser = `${market}currentUser`;
// 用户 token
export const storageToken = `${market}authToken`;

export const userPhone = `${market}userPhone`;
